module.exports = __webpack_public_path__ + "img/25.e3d887aa.png";